<div style="padding-top: 16px">
  @if (iconName) {
    <span
      matDialogTitle
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
      cdkDragBoundary=".cdk-overlay-container"
      style="cursor: move; margin-bottom: 0"
      fxLayout="row wrap"
      fxLayoutAlign="start start"
    >
      <div fxLayout="column">
        <div fxLayout="row">
          <mng-icon style="margin-right: 10px" [iconName]="iconName" [fontSize]="24" [color]="iconColor" />
          <span>{{ title }}</span>
        </div>
        @if (subTitle) {
          <div class="text-secondary subtitle">
            {{ subTitle }}
          </div>
        }
      </div>
      <span fxFlex></span>
      <ng-container *ngTemplateOutlet="contentTpl" />
    </span>
  } @else {
    <span
      matDialogTitle
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
      cdkDragBoundary=".cdk-overlay-container"
      style="cursor: move; margin-bottom: 0"
      fxLayout="row wrap"
      fxLayoutAlign="start start"
    >
      <div fxLayout="column">
        <span>{{ title }}</span>
        @if (subTitle) {
          <div class="text-secondary subtitle">
            {{ subTitle }}
          </div>
        }
      </div>
      <span fxFlex></span>
      <ng-container *ngTemplateOutlet="contentTpl" />
    </span>
  }

  <ng-template #contentTpl>
    <ng-content />
  </ng-template>
</div>
